<template>
  <div v-if="show" class="col-xs-12 col-md-3">
    <form-group-cnpj
      ref="input"
      type="text"
      :label="label"
      :readonly="readonly"
      :value="value"
      :placeholder="placeholder"
      :name="name"
      :data-vv-as="label"
      @input="$emit('input', $event)"
      @blur="blur($event)"
      v-validate="{ required: required, cnpj: true }"
    />
  </div>
</template>

<script>
import verificaTipoPessoa from "../../../../mixins/protocolo/verificaTipoPessoa";
import convenio from "../../../../mixins/protocolo/convenio";
import CnpjService from "../../../../domain/protocolo/CnpjService";
import CampoEnum from "../../../../domain/protocolo/CampoEnum";
import { mapActions } from "vuex";

export default {
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator", "formValues"],
  name: "c-protocolo-cnpj",
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    protocolo: Object,
    required: Boolean,
    loading: {
      type: Boolean,
      default: false
    }
  },
  mixins: [verificaTipoPessoa, convenio],
  data() {
    return {
      show: true,
      campoEnum: CampoEnum
    };
  },
  asyncComputed: {
    verificar() {
      this.show = this.$isJuridica(this.formValues);
    },
    setValue() {
      this.$updateValuesConvenio(this.value);
    }
  },
  mounted() {
    this.$el.value = this.value;
  },
  methods: {
    async blur(event) {
      this.$updateValuesConvenio(event);
      const validateCNPJ = await this.$validator.validate("CNPJ");
      if (validateCNPJ && event != "") {
        const serviceCnpj = new CnpjService(this.$http);
        const dadosEmpresa = await serviceCnpj.buscaDadosCnpj(event);
        this.PreencherCampos(dadosEmpresa);
      }
    },
    PreencherCampos(dadosEmpresa) {
      if (dadosEmpresa.Transacao.Status) {
        this.protocolo[this.campoEnum.NOME_EMPRESA] = dadosEmpresa.RazaoSocial;
        this.protocolo[this.campoEnum.TELEFONE_RESPONSAVEL_EMPRESA] =
          dadosEmpresa.Telefone;
        this.protocolo[this.campoEnum.EMAIL_RESPONSAVEL_EMPRESA] =
          dadosEmpresa.Email;
        if (dadosEmpresa.Enderecos && dadosEmpresa.Enderecos.length > 0) {
          this.protocolo[this.campoEnum.ENDERECO_EMPRESA] =
            dadosEmpresa.Enderecos[0].Logradouro;
          this.protocolo[this.campoEnum.ESTADO_EMPRESA] =
            dadosEmpresa.Enderecos[0].Estado;
          this.protocolo[this.campoEnum.CEP_EMPRESA] =
            dadosEmpresa.Enderecos[0].CEP;
          this.protocolo[this.campoEnum.CIDADE_EMPRESA] =
            dadosEmpresa.Enderecos[0].Cidade;
          this.protocolo[this.campoEnum.NUMERO_EMPRESA] =
            dadosEmpresa.Enderecos[0].Numero;
          this.protocolo[this.campoEnum.BAIRRO_EMPRESA] =
            dadosEmpresa.Enderecos[0].Bairro;
        }
        if (dadosEmpresa.QSA.Administradores && dadosEmpresa.QSA.Administradores.length > 0) {
          this.protocolo[this.campoEnum.NOME_RESPONSAVEL_EMPRESA] =
            dadosEmpresa.QSA.Administradores[0].Nome;
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/Campos/Cnpj.vue